export const HISTORY_DRAWER_TITLES = {
    OWNER_HISTORY: 'Owner History',
} as const;

export const HISTORY_DRAWER_DISPLAY = {
    SYSTEM_USER_FALLBACK: 'System',
    EMPTY_VALUE_DISPLAY: 'None',
} as const;

export const HISTORY_DRAWER_API_PATHS = {
    GET_HISTORY: 'account/getHistory',
} as const;
